import { useState } from 'react';
import { supabase } from '../utils/supabase';
import { errorBox, inputClass, noticeBox, primaryButton } from './AuthLayout';

/** Set or change the signed-in user's password (used after invites and password resets). */
export default function SetPassword({ onDone, buttonLabel = 'Save password' }) {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [saved, setSaved] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 8) return setError('Use at least 8 characters.');
    if (password !== confirm) return setError('The passwords do not match.');
    setLoading(true);
    const { error } = await supabase.auth.updateUser({ password });
    setLoading(false);
    if (error) return setError(error.message);
    setSaved(true);
    onDone?.();
  };

  if (saved) return <div className={noticeBox}>Password saved.</div>;

  return (
    <form onSubmit={handleSubmit} className="space-y-3">
      <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className={inputClass}
        placeholder="New password" autoComplete="new-password" required disabled={loading} />
      <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className={inputClass}
        placeholder="Confirm password" autoComplete="new-password" required disabled={loading} />
      {error && <div className={errorBox}>{error}</div>}
      <button type="submit" disabled={loading} className={primaryButton}>
        {loading ? 'Saving...' : buttonLabel}
      </button>
    </form>
  );
}
